import api from './index.js'

export default {

  getCustomerAccessByDay(params) {
    return api.get('analytics/customers_by_days.json', params);
  },
  getCustomerAccessByGenderAndAge(params) {
    return api.get('analytics/customer_counts_by_gender_and_age.json', params);
  },
  getCustomerList(params) {
    return api.get('analytics/customer_list.json', params);
  },
  getCustomerCount(params) {
    return api.get('analytics/customer_count.json', params);
  },
  getEventCountsByActionType(params) {
    return api.get('analytics/event_counts.json', params);
  },
  getEventCountsByGroup(params) {
    return api.get('analytics/group_counts.json', params);
  },
  getEventList(params) {
    return api.get('analytics/event_list.json', params);
  },
  getEventCount(params) {
    return api.get('analytics/event_count.json', params);
  },
  getEventCountsByEvent(params) {
    return api.get('analytics/event_counts_by_event.json', params);
  },
  getEventCountByDeviceType(params) {
    return api.get('analytics/event_counts_by_device_type.json', params);
  },
  getDeviceList(params) {
    return api.get('analytics/device_list.json', params);
  },
  getDeviceCount(params) {
    return api.get('analytics/device_count.json', params);
  },
  getCustomerDetails(params) {
    return api.get('analytics/customer_details.json', params);
  },
  getEnvData(params) {
    return api.get('analytics/env_data.json', params);
  },
  getEventCountsForEvent(params) {
    return api.get('analytics/event_counts_for_event.json', params);
  },
  getEventListForEvent(params) {
    return api.get('analytics/event_list_for_event.json', params);
  },
  getEventCountForEvent(params) {
    return api.get('analytics/event_count_for_event.json', params);
  },
  getCustomerEventList(params) {
    return api.get('analytics/customer_event_list.json', params);
  },
  getCustomerEventCount(params) {
    return api.get('analytics/customer_event_count.json', params);
  },
  getDeviceEventList(params) {
    return api.get('analytics/device_event_list.json', params);
  },
  getDeviceEventCount(params) {
    return api.get('analytics/device_event_count.json', params);
  },
  getEventTemps(params) {
    return api.get('analytics/event_temps.json', params)
  }
}
